package fr.frux.core.maps

import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.painter.Painter

actual val mapRendersInteractiveMarkers: Boolean = true

/**
 * Web : plus aucune acrobatie DOM. Depuis maplibre-compose 0.16, MapLibre GL JS rend dans le
 * contexte graphique de Skiko et la carte est composee dans le canvas Compose comme n'importe quel
 * contenu. Ce qui disparait avec : la vue repoussee derriere le canvas (`z-index: -1`), le trou
 * perce au `BlendMode.Clear`, le repli de gestes en Compose et la liberation manuelle du contexte
 * WebGL. L'amont appelle desormais `map.remove()` a la fermeture de sa session, donc la fuite de
 * contextes qu'on compensait a la main n'a plus de porteur.
 */
@Composable
actual fun FruxMap(
    camera: MapCameraState,
    markers: List<MapMarker>,
    userLocation: Location?,
    markerIcons: Map<String, Painter>,
    fallbackGlyph: Painter?,
    onMarkerClick: (MarkerId) -> Unit,
    onMarkerGroupClick: (List<MarkerId>) -> Unit,
    plaques: List<MapPlaque>,
    onPlaqueClick: (PlaqueId) -> Unit,
    showOrnaments: Boolean,
    attributions: List<String>,
    markerCallout: (@Composable (MarkerId) -> Unit)?,
    onUserGesture: () -> Unit,
    pyramid: MapPyramid?,
    pyramidOpacity: Float,
    onPyramidTreeClick: (MarkerId) -> Unit,
    modifier: Modifier,
) = MapLibreFruxMap(
    camera = camera,
    markers = markers,
    userLocation = userLocation,
    markerIcons = markerIcons,
    fallbackGlyph = fallbackGlyph,
    onMarkerClick = onMarkerClick,
    onMarkerGroupClick = onMarkerGroupClick,
    plaques = plaques,
    onPlaqueClick = onPlaqueClick,
    showOrnaments = showOrnaments,
    attributions = attributions,
    markerCallout = markerCallout,
    onUserGesture = onUserGesture,
    pyramid = pyramid,
    pyramidOpacity = pyramidOpacity,
    onPyramidTreeClick = onPyramidTreeClick,
    modifier = modifier,
)
